<template>
  <!--政策详情页面-->
  <tk-container :status="status" @refresh="getInit">
    <!--头部-->
    <my-header slot="header">{{$route.query.type | agreementTitle}}</my-header>
    <!--政策内容-->
    <div class="privacy-detail-box" v-if="policyDetail" v-html="policyDetail"></div>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: 'loading',
      policyDetail: null // 隐私政策详情
    }
  },
  mounted () {
    this.getInit()
  },
  filters: {
    agreementTitle (query) {
      if (query === 'privacyPolicy') { return '隐私政策' }
      if (query === 'userAgreement') { return ' 用户声明' }
    }
  },
  methods: {
    async getInit () {
      try {
        this.setStatusBar('dark')
        this.policyDetail = null
        let privacyPolicy = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/privacyPolicy').catch(e => {
          return { data: null }
        })
        let userAgreement = await this.$tkAjax.get('https://cloud.dianpei.mokekeji.com/settings/userAgreement').catch(e => {
          return { data: null }
        })
        if (privacyPolicy.data && this.$route.query.type === 'privacyPolicy') {
          this.policyDetail = privacyPolicy.data
        } else {
          this.policyDetail = userAgreement.data
        }
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .privacy-detail-box {
    background: #fff;
    padding: 12px;
  }
</style>
